// Module
var code = "<div layout=row class=gz-header-template-container><div id=agHeaderCellLabel class=gz-header-template-cell-label><div id=agText class=gz-header-template-text></div></div><div id=agResizeBar class=gz-header-template-resize-bar></div></div>";
// Exports
module.exports = code;